import React from 'react'
import { Route } from 'react-router-dom'
import ManageDefaultRoutes from '../../ManageDefaultRoutes'
import Dashboard from '../../../pages/Operational/Residential/Dashboard/Index'
import Allotment from '../../../pages/Operational/Residential/Allotment/Index'
import Hostel from '../../../pages/Operational/Residential/Hostel/Index'
import Meals from '../../../pages/Operational/Residential/Meals/Index'
import Tuition from '../../../pages/Operational/Residential/Tuition/Index'
const ResidentialRoutes = <>
    <Route path="residential/*">
        <Route index element={<ManageDefaultRoutes path="dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="allotment" element={<Allotment />} />
        <Route path="hostels" element={<Hostel />} />
        <Route path="meals" element={<Meals />} />
        <Route path="tuition" element={<Tuition />} />
    </Route>
</>

export default ResidentialRoutes